


// import { useEffect, useRef, useState } from "react";
// import html2pdf from "html2pdf.js";
// import "./CabReport.css";

// const API = "https://bodhimaram.onrender.com/api/cab";

// export default function CabReport() {
//   const [students, setStudents] = useState([]);
//   const [search, setSearch] = useState("");
//   const [selected, setSelected] = useState(null);
//   const [report, setReport] = useState([]);
//   const [showReport, setShowReport] = useState(false);
//   const [showDropdown, setShowDropdown] = useState(false);

//   const reportRef = useRef();
//   const inputRef = useRef();

//   /* ================= LOAD CAB STUDENTS ================= */
//   useEffect(() => {
//     fetch(`${API}/students`)
//       .then(res => res.json())
//       .then(setStudents);
//   }, []);

//   /* ================= FILTER STUDENTS ================= */
//   const filteredStudents = students.filter(s =>
//     `${s.childname} ${s.group_code}`
//       .toLowerCase()
//       .includes(search.toLowerCase())
//   );

//   /* ================= GET REPORT ================= */
//   const loadReport = async (cabStudent) => {
//     setSelected(cabStudent);
//     setSearch(`${cabStudent.childname} (${cabStudent.group_code})`);
//     setShowDropdown(false);

//     const res = await fetch(`${API}/report/${cabStudent.cab_student_id}`);
//     const data = await res.json();

//     setReport(Array.isArray(data) ? data : []);
//     setShowReport(true);
//   };

//   /* ================= TOTAL ================= */
//   const total = report.reduce(
//     (sum, r) => sum + Number(r.amount || 0),
//     0
//   );

//   /* ================= PDF ================= */
//   const downloadPDF = () => {
//     if (!showReport) return;

//     html2pdf()
//       .from(reportRef.current)
//       .set({
//         margin: 10,
//         filename: `Cab_Report_${selected.childname}.pdf`,
//         html2canvas: { scale: 2 },
//         jsPDF: { unit: "mm", format: "a4" }
//       })
//       .save();
//   };

//   /* ================= CLICK OUTSIDE ================= */
//   useEffect(() => {
//     const close = (e) => {
//       if (!inputRef.current?.contains(e.target)) {
//         setShowDropdown(false);
//       }
//     };
//     document.addEventListener("click", close);
//     return () => document.removeEventListener("click", close);
//   }, []);

//   return (
//     <div className="cab-report">
//       <h2>Cab Payment Report</h2>

//       {/* SEARCH INPUT */}
//       <div className="cab-search-wrap" ref={inputRef}>
//         <input
//           className="cab-search"
//           placeholder="Select student (type to search)"
//           value={search}
//           onFocus={() => setShowDropdown(true)}
//           onChange={e => {
//             setSearch(e.target.value);
//             setShowReport(false);
//             setShowDropdown(true);
//           }}
//         />

//         {/* DROPDOWN */}
//         {showDropdown && (
//           <div className="cab-dropdown">
//             {(search ? filteredStudents : students).map(s => (
//               <div
//                 key={s.cab_student_id}
//                 className="cab-option"
//                 onClick={() => loadReport(s)}
//               >
//                 {s.childname}
//                 <span> ({s.group_code})</span>
//               </div>
//             ))}

//             {(search ? filteredStudents : students).length === 0 && (
//               <div className="cab-option empty">No students found</div>
//             )}
//           </div>
//         )}
//       </div>

//       {/* REPORT */}
//       {showReport && (
//         <>
//           <button className="download-btn" onClick={downloadPDF}>
//             Download PDF
//           </button>

//           <div ref={reportRef}>
//             <p className="report-title">
//               <strong>Student:</strong> {selected.childname} &nbsp;
//               <strong>Group:</strong> {selected.group_code}
//             </p>
// <div className="cab-report-table-wrap">
//             <table className="cab-report-table">
//               <thead>
//                 <tr>
//                   <th>Year</th>
//                   <th>Month</th>
//                   <th>Status</th>
//                   <th>Mode</th>
//                   <th>Amount (₹)</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {report.length === 0 ? (
//                   <tr>
//                     <td colSpan="5" className="empty">
//                       No records found
//                     </td>
//                   </tr>
//                 ) : (
//                   report.map((r, i) => (
//                     <tr key={i}>
//                       <td>{r.year}</td>
//                       <td>{r.month}</td>
//                       <td className={r.payment_status}>
//                         {r.payment_status}
//                       </td>
//                       <td>{r.payment_mode || "-"}</td>
//                       <td>₹{Number(r.amount).toFixed(2)}</td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>

//               <tfoot>
//                 <tr>
//                   <td colSpan="4" className="total-label">
//                     Total Paid
//                   </td>
//                   <td className="total-amount">
//                     ₹{total.toFixed(2)}
//                   </td>
//                 </tr>
//               </tfoot>
//             </table>
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// }





import { useEffect, useRef, useState } from "react";
import html2pdf from "html2pdf.js";
import "./CabReport.css";

const API = "https://bodhimaram.onrender.com/api/cab";

export default function CabReport() {
  const [students, setStudents] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);
  const [report, setReport] = useState([]);
  const [showReport, setShowReport] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  const reportRef = useRef();
  const inputRef = useRef();

  /* ================= LOAD CAB STUDENTS ================= */
  useEffect(() => {
    fetch(`${API}/students`)
      .then(res => res.json())
      .then(setStudents);
  }, []);


  useEffect(() => {
  const savedStudents =
    JSON.parse(localStorage.getItem("cabStudents")) || [];

  setStudents(savedStudents);
}, []);

  /* ================= FILTER STUDENTS ================= */
  const filteredStudents = students.filter(s =>
    `${s.childname} ${s.group_code}`
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  /* ================= GET REPORT ================= */
  // const loadReport = async (cabStudent) => {
  //   setSelected(cabStudent);
  //   setSearch(`${cabStudent.childname} (${cabStudent.group_code})`);
  //   setShowDropdown(false);

  //   const res = await fetch(`${API}/report/${cabStudent.cab_student_id}`);
  //   const data = await res.json();

  //   setReport(Array.isArray(data) ? data : []);
  //   setShowReport(true);
  // };














  const loadReport = (cabStudent) => {
  setSelected(cabStudent);

  setSearch(
    `${cabStudent.childname} (${cabStudent.group_code})`
  );

  setShowDropdown(false);

  const allReports =
    JSON.parse(localStorage.getItem("cabReports")) || [];

  const studentReport = allReports.filter(
    r => r.cab_student_id === cabStudent.cab_student_id
  );

  setReport(studentReport);

  setShowReport(true);
};

  /* ================= TOTAL ================= */
  const total = report.reduce(
    (sum, r) => sum + Number(r.amount || 0),
    0
  );

  /* ================= PDF ================= */
  const downloadPDF = () => {
    if (!showReport) return;

    html2pdf()
      .from(reportRef.current)
      .set({
        margin: 10,
        filename: `Cab_Report_${selected.childname}.pdf`,
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: "a4" }
      })
      .save();
  };

  /* ================= CLICK OUTSIDE ================= */
  useEffect(() => {
    const close = (e) => {
      if (!inputRef.current?.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, []);

  return (
    <div className="cab-report">
      <h2>Cab Payment Report</h2>

      {/* SEARCH INPUT */}
      <div className="cab-search-wrap" ref={inputRef}>
        <input
          className="cab-search"
          placeholder="Select student (type to search)"
          value={search}
          onFocus={() => setShowDropdown(true)}
          onChange={e => {
            setSearch(e.target.value);
            setShowReport(false);
            setShowDropdown(true);
          }}
        />

        {/* DROPDOWN */}
        {showDropdown && (
          <div className="cab-dropdown">
            {(search ? filteredStudents : students).map(s => (
              <div
                key={s.cab_student_id}
                className="cab-option"
                onClick={() => loadReport(s)}
              >
                {s.childname}
                <span> ({s.group_code})</span>
              </div>
            ))}

            {(search ? filteredStudents : students).length === 0 && (
              <div className="cab-option empty">No students found</div>
            )}
          </div>
        )}
      </div>

      {/* REPORT */}
      {/* {showReport && (
        <>
          <button className="download-btn" onClick={downloadPDF}>
            Download PDF
          </button>

          <div ref={reportRef}>
            <p className="report-title">
              <strong>Student:</strong> {selected.childname} &nbsp;
              <strong>Group:</strong> {selected.group_code}
            </p>
<div className="cab-report-table-wrap">
            <table className="cab-report-table"> */}

            {showReport && (
  <>
    <div className="mobile-report-section">

      <div className="mobile-student-card">
        <img
          src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
          alt=""
        />

        <div>
          <h3>{selected.childname}</h3>

          <div className="student-tags">
            <span>{selected.group_code}</span>
            <span>Cab No: TN 09 AB 1234</span>
          </div>
        </div>
      </div>

      <div className="mobile-report-header">
        <div>
          <h3>Payment Report</h3>
          <p>Monthly payment details</p>
        </div>

        <button
          className="download-btn"
          onClick={downloadPDF}
        >
          Download PDF
        </button>
      </div>

    </div>

    <div ref={reportRef}>

      <div className="cab-report-table-wrap">
        <table className="cab-report-table">
              <thead>
                <tr>
                  <th>Year</th>
                  <th>Month</th>
                  <th>Status</th>
                  <th>Mode</th>
                  <th>Amount (₹)</th>
                </tr>
              </thead>

              <tbody>
                {report.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="empty">
                      No records found
                    </td>
                  </tr>
                ) : (
                  report.map((r, i) => (
                    <tr key={i}>
                      <td>{r.year}</td>
                      <td>{r.month}</td>
                      <td className={r.payment_status}>
                        {r.payment_status}
                      </td>
                      <td>{r.payment_mode || "-"}</td>
                      <td>₹{Number(r.amount).toFixed(2)}</td>
                    </tr>
                  ))
                )}
              </tbody>

              <tfoot>
                <tr>
                  <td colSpan="4" className="total-label">
                    Total Paid
                  </td>
                  <td className="total-amount">
                    ₹{total.toFixed(2)}
                  </td>
                </tr>
              </tfoot>
            </table>

            
            </div>
          </div>
        </>
      )}
    </div>
  );
}
